<template>
  <div>
    <v-menu
      v-model="data.Records[0].menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :label="label"
          prepend-inner-icon="mdi-calendar"
          readonly
          outlined
          background-color="white"
          :value="data.Records[0].value"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="data.Records[0].value"
        no-title
        scrollable
        @input="data.Records[0].menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    record: Object,
    label: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: null, form_id: 0, form_type: 3, menu: false }],
      },
    };
  },
  async mounted() {
    //console.log("Calneder form Mounted");
  },
};
</script>

<style></style>
